<template>
    
    <v-list
        class="py-0 ml-10 horizontal-list-menu"
        flat
    >
        <v-list-item
            @click="seeAll"
            data-testid="dashboard-item"
            :class="{'accent--text': $route.name ==='Dashboard'}"
            background-color="background"
        >
            <v-list-item-title>{{ $t('dashboard') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            @click="showActivityPage"
            v-if="$route.name === 'Dashboard' || $route.name === 'AllHubs' || $route.name === 'AllActivities'"
            data-testid="activities-item"
            :class="{'accent--text': $route.name ==='AllActivities'}"
            class="pl-1"
        >
            {{ $t('activitiesItem') }}
        </v-list-item> 
        <v-list-item 
            @click="showhubPage"
            v-if="$route.name === 'Dashboard' || $route.name === 'AllHubs' || $route.name === 'AllActivities'"
            :disabled="productPlan.attributes && productPlan.attributes.name === 'Free'" 
            data-testid="hubs-item"
            :class="{'accent--text': $route.name ==='AllHubs'}"
            class="pl-1"
        >
            {{ $t('hubItem') }}
            <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg ml-2 px-2" x-small color="accent" text-color="white">PRO</v-chip>
        </v-list-item> 
    </v-list> 
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
export default {
mixins: [repeatedMethodsMixin],
data: function() {
    return { 
        role: localStorage.space ? JSON.parse(localStorage.space).role : null,
    }
},
computed: {
    productPlan() {
        return this.$store.state.productPlan;
    },
},
methods: {
    seeAll(){
        if (this.role == 'space_admin' || this.role == 'booster') {
            this.$router.push({path: '/dashboard'}) 
        } else if (this.role == 'participant' || this.role == 'guest') {
            this.$router.push({path: '/dashboard-participant'})
        }
    },
    showActivityPage(){
        if (this.role == 'space_admin' || this.role == 'booster') {
            this.$router.push({path: '/all-activities'}) 
        } else if (this.role == 'participant' || this.role == 'guest') {
            this.$router.push({path: '/all-activities-participant'})
        } 
    },
    showhubPage(){
        if (this.role == 'space_admin' || this.role == 'booster') {
            this.$router.push({path: '/all-hubs'}) 
        } else if (this.role == 'participant' || this.role == 'guest') {
            this.$router.push({path: '/all-hubs-participant'})
        }
    }
},
}

</script>
<style>
.horizontal-list-menu {
    background-color: var(--background) !important;
}
</style>